import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import nl from './nl.json';
import pl from './pl.json';
import pt from './pt.json';
import sv from './sv.json';
import tr from './tr.json';
import vi from './vi.json';
import zh from './zh.json';

export const localizedMessages = {
  en,
  es,
  fr,
  it,
  ja,
  ko,
  nl,
  pt,
  tr,
  vi,
  zh,
  pl,
  sv,
};
